import { Dispatch, createContext } from "react";
import { State, Action, MetricsType, MetricsUnit, TimeFrame } from "./types";
import { Sorting } from "../types";
import { reducer } from "./reducer";
import {
  createStateHook,
  createDispatchHook,
  createContextHook,
  createProvider,
} from "../../factory";
import { getTimeFrameRange } from "../../../components/Reports/Utilities/utils";
import { getPersisted } from "../../../utils/storage";
import { UTILITIES_PERSIST_KEY, TIMEFRAME_PERSIST_PROP } from "./constants";

// Retrieve default time frame range
const persistedTimeFrame = getPersisted(
  { prop: TIMEFRAME_PERSIST_PROP, key: UTILITIES_PERSIST_KEY },
  TimeFrame.Last2Years
);
const { timeFrameOption, startDate, endDate } =
  getTimeFrameRange(persistedTimeFrame);

/**
 * The initial state of utilities
 */
export const initialState: State = {
  timeFrameOption,
  startDate,
  endDate,
  sortingDirection: {
    rankedYears: Sorting.Desc, // Years always to be DESC
    rankedSites: Sorting.Desc,
  },
  metricsLoading: false,
  metricsLoadingError: false,
  metricsLoaded: {
    [MetricsType.Electricity]: false,
    [MetricsType.Gas]: false,
    [MetricsType.Water]: false,
  },
  metricsType: MetricsType.Electricity,
  metricsUnit: MetricsUnit.Electricity,
  metrics: {},
  selectedSites: [],
};

const stateContext = createContext<State | undefined>(undefined);
const dispatchContext = createContext<Dispatch<Action> | undefined>(undefined);

export const UtilitiesProvider = createProvider(
  stateContext,
  dispatchContext,
  reducer,
  initialState
);
export const useState = createStateHook(stateContext);
export const useDispatch = createDispatchHook(dispatchContext);
export const useUtilities = createContextHook(stateContext, dispatchContext);
